// extracted by mini-css-extract-plugin
export var dropdown = "_s5-0";
export var imageWrapper = "_s5-3";
export var itemNameContainer = "_s5-1";
export var productImage = "_s5-2";
export var spinnerWrapper = "_s5-4";